import {
  doc,
  getDoc,
  getFirestore,
  serverTimestamp,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore/lite";

export type TProfile = {
  avatar: string | null;
  name: string;
  lastName?: string;
  birthday: string | null;
  phoneNumber?: string | null;
  bio?: string | null;

  address1?: string | null;
  address2?: string | null;
  state?: string | null;
  country: string | null;

  gender?: string | null;
  language?: string;
  interests?: string[];
  isOnboardingDone?: boolean;
  timespent?: number;
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
};

export function getUserProfile({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: TProfile) => void;
  onError?: (error: any) => void;
}) {
  const db = getFirestore();
  const uid = localStorage.getItem("uid");

  if (!uid) {
    onError?.("UID não encontrado");
    return;
  }

  const profileDocRef = doc(db, "profile", uid);

  getDoc(profileDocRef)
    .then((docSnap) => {
      if (docSnap.exists()) {
        const profileData = docSnap.data() as TProfile;
        onSuccess?.(profileData);
      } else {
        onError?.("Perfil não encontrado");
      }
    })
    .catch((error) => {
      console.error("Erro ao buscar perfil:", error);
      onError?.(error);
    });
}

export function createUserProfile({
  data,
  onSuccess,
  onError,
}: {
  data: Omit<TProfile, "createdAt" | "updatedAt">;
  onSuccess?: (data: TProfile) => void;
  onError?: (error: any) => void;
}) {
  const db = getFirestore();
  const uid = localStorage.getItem("uid");

  if (!uid) {
    onError?.("UID não encontrado");
    return;
  }

  const profileDocRef = doc(db, "profile", uid);

  const dataToSet = {
    ...data,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };

  setDoc(profileDocRef, dataToSet)
    .then(() => {
      return getDoc(profileDocRef);
    })
    .then((docSnap) => {
      if (docSnap.exists()) {
        const profileData = docSnap.data() as TProfile;
        onSuccess?.(profileData);
      } else {
        throw new Error("Documento não encontrado após criação bem-sucedida.");
      }
    })
    .catch((error) => {
      console.error("Erro ao criar ou buscar perfil após criar:", error);
      onError?.(error);
    });
}

export function updateUserProfileFields({
  data,
  onSuccess,
  onError,
}: {
  data: Partial<Omit<TProfile, "createdAt">>;
  onSuccess?: (data: TProfile) => void;
  onError?: (error: any) => void;
}) {
  const db = getFirestore();
  const uid = localStorage.getItem("uid");

  if (!uid) {
    onError?.("UID não encontrado");
    return;
  }

  const profileDocRef = doc(db, "profile", uid);

  const updateData = data;

  const dataToUpdate = {
    ...updateData,
    updatedAt: serverTimestamp(),
  };

  updateDoc(profileDocRef, dataToUpdate)
    .then(() => {
      return getDoc(profileDocRef);
    })
    .then((docSnap) => {
      if (docSnap.exists()) {
        const profileData = docSnap.data() as TProfile;
        onSuccess?.(profileData);
      } else {
        throw new Error(
          "Documento não encontrado após atualização bem-sucedida."
        );
      }
    })
    .catch((error) => {
      console.error(
        "Erro ao atualizar ou buscar perfil após atualizar:",
        error
      );
      onError?.(error);
    });
}
